<template>
  <div class="card product-card">
    <div class="card-body">
      <img :src="'https://xpanel.s-bar.ir/' + service.icon" class="image" alt="product image"
        style="height: 7rem;">
      <h2 class="title">{{ service.title }}</h2>
      <p class="text text-TEAL">خدمات</p>
      <!-- <div class="price">30,000 تومان</div> -->

      <a :href="service.link" class="btn btn-sm background-blue text-light btn-block">ورود به لینک</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceView",
  props: {
    service: Object
  },
}
</script>

<style scoped></style>